import { render } from "./LoginPage.vue?vue&type=template&id=315b4979&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "../styles/login.css?vue&type=style&index=0&id=315b4979&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315b4979"]])

export default __exports__